import React from 'react'
import "./Checkout.css";
import Subtotal from "./Subtotal";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";

function Checkout() {
  const [{ basket, user }, dispatch] = useStateValue();

    return (
        <div className="checkout">
        <div className="checkout__left">
          <img
            className="checkout__ad"
            src="http://www.frangardino.com/clouds/longcloud2aweb1.jpg"
            alt=""
           />
        <div>
          <h3>Welcome, {user?.email}!</h3>
            <h2 className="checkout__title">Your Shopping Basket</h2>
            {basket.map(item => (
            <CheckoutProduct
              id={item.id}
              title={item.title}
              image={item.image}
              price={item.price}
              rating={item.rating}
              number={item.number}
              name={item.name}
            />
          ))}    
            </div>
        </div>

        <div className="checkout__right">
            <Subtotal />
            
            </div>
        </div>
    );
}

export default Checkout;
